import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Tab } from '@headlessui/react';
import { generateWorkoutPdf } from '../utils/pdfGenerator';
import { generateNutritionPdf } from '../utils/pdfNutrition';
import { FaMoon, FaSun, FaDumbbell } from 'react-icons/fa';
import VideoPlayer from '../VideoPlayer';

export default function AdminPlanDetails() {
  const { id: planId } = useParams();
  const [dark, setDark] = useState(true);
  const [plan, setPlan] = useState([]);
  const [nutrition, setNutrition] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [tabIndex, setTabIndex] = useState(0);
  const API_URL = process.env.REACT_APP_API_URL;
const weekDayMap = {
  Saturday: 'شنبه',
  Sunday: 'یکشنبه',
  Monday: 'دوشنبه',
  Tuesday: 'سه‌شنبه',
  Wednesday: 'چهارشنبه',
  Thursday: 'پنجشنبه',
  Friday: 'جمعه'
};
const mealTypeMap = {
  Breakfast: 'صبحانه',
  MorningSnack: 'میان‌وعده صبح',
  Lunch: 'ناهار',
  AfternoonSnack: 'میان‌وعده عصر',
  Dinner: 'شام',
  EveningSnack: 'میان‌وعده غروب',
  NightSnack: 'میان‌وعده شب',
  Snacks: 'میان‌وعده شب'
};
  const headers = {
    Authorization: `Bearer ${localStorage.getItem('admin_token')}`
  };

  useEffect(() => {
    fetchData();
  }, [planId]);

const confirmPlan = async () => {

  try {
    const res = await fetch(`https://api.mogym.ir/api/admin/plan/${planId}/confirm`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('admin_token')}`
      }
    });

    if (!res.ok) {
      const errData = await res.json();
      throw new Error(errData?.Message || 'خطا در تأیید برنامه');
    }

    alert('✅ برنامه با موفقیت تأیید شد.');
  } catch (err) {
    alert(`❌ خطا در تأیید برنامه: ${err.message}`);
  }
};


    const fetchData = async () => {
      try {
        const [workoutRes, nutritionRes] = await Promise.all([
          fetch(`https://api.mogym.ir/api/admin/plan/${planId}/workout`, { headers }),
          fetch(`https://api.mogym.ir/api/admin/plan/${planId}/meal`, { headers })
        ]);

        if (!workoutRes.ok || !nutritionRes.ok) throw new Error();

        const workoutData = await workoutRes.json();
        const nutritionData = await nutritionRes.json();
        setPlan(workoutData.Result || []);
        setNutrition(nutritionData.Result || []);
      } catch (err) {
        setError('خطا در دریافت برنامه.');
      } finally {
        setLoading(false);
      }
    };


const renderWorkout = () => {
  if (!plan || !Array.isArray(plan) || plan.length === 0) {
    return <p>📭 برنامه تمرینی پیدا نشد.</p>;
  }

  return (
    <div className="space-y-6">
      <button
        onClick={() => generateWorkoutPdf(plan)}
        className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-xl"
      >
        دانلود برنامه تمرینی (PDF)
      </button>

      {plan.map((day, idx) => (
        <div key={idx} className="bg-gray-50 dark:bg-[#1c1f2b] p-5 rounded-xl shadow">
          <h2 className="text-xl font-bold mb-3">🗓 {day.DayOfWeek} - عضله هدف: {day.MuscleGroup}</h2>
          
          {day.WorkoutGroups.map((group, gIdx) => (
            <div key={gIdx} className="mb-4 border-t border-gray-300 pt-4">
              <h3 className="text-lg font-semibold mb-2 flex items-center gap-2">
                <FaDumbbell className="text-blue-500" />
                {group.Type === 'Superset' ? 'سوپرست' : group.Type === 'Dropset' ? 'دراپ‌ست' : 'تمرین'} #{group.GroupId}
              </h3>

              {group.ExerciseRecords.map((ex, i) => (
                <div key={i} className="bg-blue-50 dark:bg-[#2a2f3b] p-3 rounded-xl mb-3">
                  <p className="font-bold">🔹 {ex.Name}</p>
                  <p className="text-sm">{ex.Sets} ست × {ex.Reps} تکرار</p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">🕒 استراحت: {ex.RestSeconds} ثانیه</p>
<VideoPlayer url={ex.VideoUrl} title={ex.Name} exerciseId={ex.ExerciseId} />

                  <p className="text-sm mt-1">{ex.Description}</p>
                </div>
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};


const renderNutrition = () => {
  const result = nutrition;
 if (
    !result ||                          // چک null یا undefined
    !result.Days ||                     // چک نبودن Days
    !Array.isArray(result.Days) ||      // چک اینکه Days آرایه باشد
    result.Days.length === 0            // چک خالی بودن آرایه
  ) {
    return <p>📭 برنامه تغذیه‌ای پیدا نشد.</p>;
  }
  return (
    <div className="space-y-6">
      <div className="bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-200 p-4 rounded-xl">
        <p>کالری هدف: {result.TotalCalories} kcal</p>
        <p>پروتئین: {result.TotalProteinGrams}g | کربوهیدرات: {result.TotalCarbsGrams}g | چربی: {result.TotalFatGrams}g</p>
      </div>

      <button
        onClick={() => generateNutritionPdf(result)}
        className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-xl"
      >
        دانلود برنامه تغذیه‌ای (PDF)
      </button>

{result.Days.map((dayItem, idx) => (
  <div key={idx} className="bg-purple-50 dark:bg-[#2f2b3f] p-5 rounded-xl shadow">
    <h2 className="text-lg font-bold mb-4">📅 {weekDayMap[dayItem.Day]}</h2>

    {dayItem.Meals.map((meal, mealIdx) => (
      <div key={mealIdx} className="mb-6">
        <h3 className="font-semibold mb-2 text-purple-700 dark:text-purple-200">🍽 {mealTypeMap[meal.MealType]}</h3>

        {meal.Options.map((option, optionIdx) => (
          <div key={optionIdx} className="pl-4 mb-2">
            <p className="text-sm font-medium text-gray-600 dark:text-gray-300">
              گزینه {optionIdx + 1}:
            </p>
            <ul className="list-disc pr-5 text-sm text-gray-700 dark:text-gray-200">
              {option.Items.map((item, itemIdx) => (
                <li key={itemIdx}>
                  {item.Name} - {item.Quantity}
                </li>
              ))}
            </ul>
          </div>
        ))}

        {meal.Supplements.length > 0 && (
          <div className="mt-2 pl-4">
            <p className="text-sm font-medium text-green-700 dark:text-green-300">💊 مکمل:</p>
            <ul className="list-disc pr-5 text-sm text-gray-700 dark:text-gray-200">
              {meal.Supplements.map((supp, sIdx) => (
                <li key={sIdx}>
                  {supp.Name} - {supp.Quantity}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    ))}
  </div>
))}

    </div>
  );
};

  return (
    <div className={dark ? 'dark' : ''}>
      <div className="min-h-screen bg-white dark:bg-[#0e1015] text-black dark:text-white px-4 py-8 font-vazir">
        <div className="max-w-3xl mx-auto space-y-6">
          <h1 className="text-2xl font-bold text-center mb-6">جزئیات برنامه #{planId}</h1>

          <Tab.Group selectedIndex={tabIndex} onChange={setTabIndex}>
            <Tab.List className="flex gap-4 bg-gray-200 dark:bg-gray-700 p-1 rounded-xl">
              <Tab className={({ selected }) =>
                selected ? 'bg-blue-600 text-white px-4 py-2 rounded-xl' : 'px-4 py-2 rounded-xl text-gray-700 dark:text-gray-300'}>
                برنامه تمرینی
              </Tab>
              <Tab className={({ selected }) =>
                selected ? 'bg-purple-600 text-white px-4 py-2 rounded-xl' : 'px-4 py-2 rounded-xl text-gray-700 dark:text-gray-300'}>
                برنامه تغذیه‌ای
              </Tab>
            </Tab.List>

            <Tab.Panels className="mt-6">
              <Tab.Panel>{loading ? 'در حال بارگذاری...' : error ? error : renderWorkout()}</Tab.Panel>
              <Tab.Panel>{loading ? 'در حال بارگذاری...' : error ? error : renderNutrition()}</Tab.Panel>
            </Tab.Panels>
          </Tab.Group>
        </div>

        <button onClick={() => setDark(!dark)}
          className="fixed top-4 right-4 z-50 px-3 py-2 bg-gray-700 text-white rounded-full shadow-lg">
          {dark ? <FaSun /> : <FaMoon />}
        </button>
        <div className="mt-12 text-center">
  <button
    onClick={confirmPlan}
    className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-xl text-lg"
  >
    ✅ تأیید نهایی برنامه
  </button>
</div>

      </div>
    </div>
  );
}
